/* eslint-disable react/no-multi-comp */

import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from '../Tooltip';

import '../CustomIcon/styles.css';
import './styles.css';

const SettingItem = ({ name, action, tooltip }) => {
  const listItem = (
    <li key={name}>
      <a href="#" onClick={action}>
        {name}
      </a>
    </li>
  );

  if (tooltip) {
    return <Tooltip title={tooltip}>{listItem}</Tooltip>;
  }

  return listItem;
};


SettingItem.propTypes = {
  name: PropTypes.string.isRequired,
  action: PropTypes.func.isRequired,
  tooltip: PropTypes.string,
};

/* eslint-disable react/no-danger */
const SettingsList = ({ settings, warningMessage, children, show }) => {
  if (show) {
    return (
      <div className="settings-list">
        {warningMessage && (
          <div className="settings-list-warning">
            <span className="custom-icon custom-icon-circle custom-icon-small custom-icon-warning custom-icon-warning-shadow">
              !
            </span>
            <span className="settings-list-warning-message">
              <div dangerouslySetInnerHTML={{ __html: warningMessage }} />
            </span>
          </div>
        )}
        <h2>Settings</h2>
        <ul>
          {settings.map(({ name, action, tooltip }) => (
            <SettingItem key={name} name={name} action={action} tooltip={tooltip} />
          ))}
        </ul>
      </div>
    );
  } else if (children) {
    return children;
  }

  return null;
};
/* eslint-enable react/no-danger */

SettingsList.propTypes = {
  settings: PropTypes.array.isRequired,
  children: PropTypes.node,
  show: PropTypes.bool,
  warningMessage: PropTypes.string
};

export default SettingsList;
